<!-- eslint-disable vue/multi-word-component-names -->
<script lang="ts" setup>
import { useTask } from "@/composables/tasks/useTask";
import { useRoute } from "vue-router";
import { normalizeRouteParam } from "@/utils/v2/routes";
import { TasksService } from "@/services/v2/tasks";
import { useTasksStore } from "@/stores/v2";
import { onMounted, ref } from "vue";

import LayoutMain from '@/components/v2/Layouts/LayoutMain.vue';
import TaskAnimalTransfer from '@/components/v2/Tasks/AnimalTransfer/index.vue';

const { startObserver } = useTask();
const route = useRoute();
const taskKey = normalizeRouteParam(route.params.key);

const isLoading = ref(true);
const error = ref('');

const initTask = async () => {
  isLoading.value = true;
  error.value = '';

  if (!taskKey) {
    error.value = 'Invalid task key';
    isLoading.value = false;
    return;
  }

  try {
    const task = await TasksService.startTask(taskKey);
    if (!task) {
      error.value = 'Task not found';
      isLoading.value = false;
      return;
    }
    await useTasksStore().setActiveTask(task);
    startObserver();
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Failed to load task';
  } finally {
    isLoading.value = false;
  }
};

const handleRetry = () => {
  initTask();
};

onMounted(initTask);
</script>

<template>
    <LayoutMain>
        <template #mainArea>
            <div v-if="isLoading" class="flex justify-center items-center h-full">
                <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            </div>

            <div v-else-if="error" class="flex flex-col justify-center items-center h-full">
                <div class="text-red-500 mb-4">{{ error }}</div>
                <button @click="handleRetry" class="px-4 py-2 bg-primary text-white rounded">Retry</button>
            </div>

            <TaskAnimalTransfer v-else />
        </template>
    </LayoutMain>
</template>